import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const NAV_CACHE = "debii-nav";
const MAX_AGE = 10 * 60 * 1000;
const safePath = (p) => typeof p === "string" && p.startsWith("/") && !p.startsWith("//");

// Routes notification taps: live postMessage from the push worker, or a parked
// destination when the app was opened/resumed without the target URL.
export function NotificationNavBridge() {
  const navigate = useNavigate();
  useEffect(() => {
    const clear = () => caches.open(NAV_CACHE).then((c) => c.delete("/pending")).catch(() => {});
    const consume = async () => {
      try {
        if (!("caches" in window)) return;
        const c = await caches.open(NAV_CACHE);
        const r = await c.match("/pending");
        if (!r) return;
        await c.delete("/pending");
        const { path, at } = await r.json();
        if (safePath(path) && Date.now() - at < MAX_AGE) navigate(path);
      } catch {
        /* ignore */
      }
    };
    const onVis = () => document.visibilityState === "visible" && consume();
    const onMsg = (e) => {
      if (e.data?.type === "debii-navigate" && safePath(e.data.path)) {
        clear();
        navigate(e.data.path);
      }
    };
    consume();
    document.addEventListener("visibilitychange", onVis);
    navigator.serviceWorker?.addEventListener("message", onMsg);
    return () => {
      document.removeEventListener("visibilitychange", onVis);
      navigator.serviceWorker?.removeEventListener("message", onMsg);
    };
  }, [navigate]);
  return null;
}
